import { getGlobalData } from "@carnet/api/backoffice";
import type { GlobalDataResource } from "@carnet/api/backoffice";

export async function useGlobalData() {
  const nuxtApp = useNuxtApp();

  const { data } = await useAsyncData<GlobalDataResource | null>(
    "global-data",
    async () => {
      const response = await getGlobalData({ composable: "$fetch", path: { locale: appLocale() } });
      return response?.data ?? null;
    },
    {
      getCachedData: (key) => {
        const cached = nuxtApp.payload.data[key] ?? nuxtApp.static.data[key];
        return cached ?? undefined;
      },
      lazy: true,
    }
  );

  return data;
}
